import React from "react";

export default function ViewAllTitle({title, className, viewButtonColor, hasViewAllBtn = true, viewAllTitle = "View all", onViewAll, mobile=true, titleMargin, isLoading = false}) {
  return (
    <div className={`text-dark mb-2 flex start justify-between space-x-4 ${mobile? 'm-5': titleMargin ?? 'mx-24 mt-8'}${className ? ` ${className}` : ''}`}>
      {isLoading ? <div className={`${mobile ? "h-6" : "h-7"} bg-loader w-24`}/> : 
        <>
          <div className={`truncate${mobile ? " text-base font-bold" : " text-xl font-medium"}`}>{title}</div>
          {hasViewAllBtn && <div onClick={onViewAll} className={`${mobile ? "text-xs" : "text-base"} cursor-pointer shrink-0 ${viewButtonColor ? viewButtonColor : "text-quaternary" }`}>{viewAllTitle}</div>} 
        </>
      }      
    </div>
  );
}
